import { motion } from "framer-motion";
import { Award, TrendingUp } from "lucide-react";
import Counter from "./Counter";
import { STATS, RECRUITERS, COLLEGE } from "../../lib/constants";

const Placements = () => {
  const marqueeList = [...RECRUITERS, ...RECRUITERS];
  return (
    <section
      id="placements"
      className="relative py-20 md:py-28 bg-megha-primary text-white overflow-hidden"
      data-testid="section-placements"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 grid-pattern opacity-10" />
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-megha-accent/30 blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-megha-highlight/15 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-megha-highlight">
              Placements 2026
            </div>
            <h2 className="mt-2 font-heading font-black text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Highest package secured by an MIETW graduate this year.
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-5"
          >
            <div className="relative rounded-3xl glass-dark border-white/20 p-8 text-center" data-testid="hero-highest-package">
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-megha-highlight text-megha-text text-[11px] font-extrabold tracking-wider uppercase shadow-lg">
                <Award className="w-3.5 h-3.5" /> Top Offer
              </div>
              <div className="text-xs tracking-[0.18em] uppercase text-blue-100/80 mb-2">Highest Package</div>
              <div className="font-heading font-black text-[88px] md:text-[120px] leading-none text-megha-highlight">
                36
              </div>
              <div className="font-heading font-extrabold text-2xl md:text-3xl mt-1">LPA</div>
              <div className="mt-3 text-sm text-blue-100/80 flex items-center justify-center gap-1.5">
                <TrendingUp className="w-4 h-4" /> Up 28% YoY · multiple 10+ LPA offers
              </div>
            </div>
          </motion.div>
        </div>

        {/* Counters */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              className="rounded-2xl bg-white/5 border border-white/15 p-6 backdrop-blur-md hover:bg-white/10 transition-colors"
              data-testid={`stat-${s.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="font-heading font-black text-4xl md:text-5xl text-white">
                <Counter to={s.value} suffix={s.suffix} />
              </div>
              <div className="text-xs font-bold tracking-[0.16em] uppercase text-blue-100/80 mt-2">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>

        {/* Recruiter marquee */}
        <div className="mt-16">
          <div className="text-center text-xs font-bold tracking-[0.18em] uppercase text-blue-100/70 mb-6">
            Top Recruiters
          </div>
          <div className="relative overflow-hidden" data-testid="marquee-recruiters">
            <div className="flex gap-12 animate-marquee whitespace-nowrap">
              {marqueeList.map((r, idx) => (
                <div
                  key={`${r}-${idx}`}
                  className="font-heading font-extrabold text-2xl md:text-3xl text-white/55 hover:text-white transition-colors tracking-tight"
                >
                  {r}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Placements;
